import $ from 'jquery';
var lightGallery = require('lightgallery');


let helpers = {

  init(){
    this.hoverMenuItem();
    this.clickTeamAccordion();
    this.iframeWrapper();
    this.initGallery();
    this.clickBurger();
    this.initPostsFilter();
  },


  clickBurger(){
    $('.burger-mobile').click((e) => {
      e.preventDefault();
      $(e.currentTarget).find('.burger').toggleClass('open');
      $(e.currentTarget).parent().children('.main').toggleClass('show');
    })
  },

  hoverMenuItem(){
    $('.header__menu .menu .menu-item-has-children > a').click((e) => {
      const url = $(e.currentTarget).attr('href');
      if (url.indexOf('#') !== -1) {
        e.preventDefault();
      }
    });
    if( $(window).width() > 992 ){
      $('.header__menu .menu .menu-item-has-children').mouseenter((e) => {
        if($(e.currentTarget).find('li').length > 0) {
          $(e.currentTarget).addClass('open');
        }
      })
      $('.header__menu .menu .menu-item-has-children').mouseleave((e) => {
        $(e.currentTarget).removeClass('open');
      })
    }

    if( $(window).width() <= 992 ){
      $('.header__menu .menu .menu-item-has-children a').click((e) => {
        if($(e.currentTarget).parent().find('li').length > 0) {
          e.preventDefault();
          $(e.currentTarget).parent().find('.sub-menu').slideToggle();
          // $(e.currentTarget).siblings().find('.sub-menu').slideUp();
        }
      })
    }
  },

  clickTeamAccordion(){
    $('.accordion__item__head').click((e) => {
      e.preventDefault();
      $(e.currentTarget).parent().find('.accordion__item__main').slideToggle();
      $(e.currentTarget).parent().toggleClass('open');
      $(e.currentTarget).parent().siblings().find('.accordion__item__main').slideUp();
      $(e.currentTarget).parent().siblings().removeClass('open');
    })
  },

    iframeWrapper() {
        if ($('iframe').length > 0) {
            $('iframe').each((index, el) => {
                var src = $(el).attr('src');
                // Check if src is defined before calling includes
                if (src && (src.includes('youtube') || src.includes('vimeo'))) {
                    $(el).wrap('<div class="iframe-wrapper" />');
                }
            });
            $('iframe').css('opacity', '1');
        }
    },

  initGallery(){
    $(".gallery__grid").lightGallery({
      selector: '.gallery__item',
      download: false,
    });
  },

  initPostsFilter() {
    $('.filter-posts').click(function(e) {
      e.preventDefault();
      let cat = $(this).data('cat');
      if(cat == 'all') {
        $('.item-row').fadeIn();
        return;
      }
      $('.item-row[data-cat][data-cat!="'+cat+'"]').fadeOut();
      $('.item-row[data-cat][data-cat="'+cat+'"]').fadeIn();
    });
  }

}
export default helpers;
